import { Typography } from '@material-ui/core';
import React, { FC } from 'react';
import useStyles from './styles';

export enum EBadgeStatus {
  INVERSE = 'inverse',
  ACTION = 'action',
  DEFAULT = 'default',
  RETURNING = 'returning',
  INVITATION = 'invitation',
  DISCONNECT = 'disconnect'
}

interface IJetStatusBadge {
  status: EBadgeStatus;
  badgeText: string;
  textWeigth?: 'bold' | 'regular';
  iconComponent?: React.ReactNode
}

export const JetStatusBadge: FC<IJetStatusBadge> = ({ status, badgeText,textWeigth = 'bold',iconComponent }) => {
  const classes = useStyles();

  return (
    <>
    
    <Typography
      variant="body1"
      className={`${classes.jetStatusBadge}  body_small_${textWeigth} ${status}`}
    >
      {iconComponent ? iconComponent : null }{badgeText}
    </Typography>
    </>
  );
};
